var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseIcon = function SvgCloseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "M4.395 3.03 3.03 4.395 10.635 12l-7.65 7.665 1.35 1.35L12 13.365l7.65 7.65 1.365-1.365-7.65-7.65 7.605-7.605-1.365-1.365L12 10.635z"
  })));
};
export default SvgCloseIcon;